const useMixins = () => {
  const convertObjectToArray = (listData) => {
    const dataArray = [];
    for (const rowname in listData) {
      if (rowname != 'id') {
        const rowData = { ...listData[rowname], rowname };
        dataArray.push(rowData);
      }
    }
    return dataArray;
  };
  const convertArrayToObject = (dataArray) => {
    const convertedObject = {};
    for (const item of dataArray) {
      const { rowname, ...rest } = item;
      convertedObject[rowname] = rest;
    }
    return convertedObject;
  };

  return {
    convertObjectToArray,
    convertArrayToObject
  };
};
export { useMixins };
